export default __webpack_public_path__ + "static/media/My-Cart.eef2e13b.jpg";